var $44177fdbbad1a686$exports = {};
$44177fdbbad1a686$exports = {
    "longPressMessage": `Appuyez de mani\xe8re prolong\xe9e ou appuyez sur Alt\xa0+\xa0Fl\xe8che vers le bas pour ouvrir le menu.`
};


export {$44177fdbbad1a686$exports as default};
//# sourceMappingURL=fr-FR.mjs.map
